import { t } from "@lingui/macro";
import * as React from "react";
import { ClipPath, Defs, G, Path, Rect } from "react-native-svg";

import { Icon, IconProps } from "../../../primitive";

export const HockeyIcon = (props: IconProps) => (
  <Icon
    viewBox="0 0 16 16"
    fill="none"
    color="currentColor"
    title={t`Hockey`}
    {...props}
  >
    <G clip-path="url(#clip0_7671_42732)" fill="none">
      <Path
        d="M0 12C0 11.4477 0.447715 11 1 11L3 11V16H1C0.447715 16 0 15.5523 0 15V12Z"
        fill="currentColor"
      />
      <Path
        d="M15.3871 1.40082C15.6762 0.740131 15.1921 0 14.471 0H12.6439C12.2518 0 11.8958 0.229203 11.7335 0.586197L7.79936 9.24141C7.31255 10.3124 6.24469 11 5.06826 11H4.5L4.5 16H7.03795C8.22985 16 9.30869 15.2944 9.78643 14.2025L15.3871 1.40082Z"
        fill="currentColor"
      />
    </G>
    <Defs>
      <ClipPath id="clip0_7671_42732">
        <Rect width="16" height="16" fill="none" />
      </ClipPath>
    </Defs>
  </Icon>
);
